<template>
    <div v-if="data">
        <h3 class="mb-1">Vse skupaj za plačilo</h3>
        <div class="overflow-auto">
            <table class="w-100 overflow-auto">
                <thead>
                    <tr>
                        <th>Naziv</th>
                        <th>Skupaj (€)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Osnova za DDV</td>
                        <td>{{ convertFloat(data.osnova_ddv) }}</td>
                    </tr>
                    <tr>
                        <td>
                            DDV skupaj
                        </td>
                        <td>
                            {{ convertFloat(data.znesek_ddv) }}
                        </td>
                    </tr>
                    <tr>
                        <td>Skupaj stroški</td>
                        <td>{{ convertFloat(data.skupaj_zddv) }}</td>
                    </tr>
                    <tr v-if="data.poraba_rezervega_sklada_skupaj_zddv !== 0">
                        <td>
                            Skupaj poraba sred. rezervnega sklada
                        </td>
                        <td>
                            {{ convertFloat(data.poraba_rezervega_sklada_skupaj_zddv) }}
                        </td>
                    </tr>
                    <tr class="colored">
                        <th>
                            Skupni znesek za plačilo
                        </th>
                        <th>
                            {{ convertFloat(data.vse_skupaj_zddv) }}
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import {convertFloat} from '@/libs/helpers'

    export default {
        methods: {convertFloat},
        props: {
            data: {
                type: Object,
                default: undefined
            }
        }
    }
</script>